import qs from 'qs';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Status } from 'src/graphql/types';
import { getUserID } from '../../libs/auth/index';
import PageNotFound from '../page-not-found';
import {
  IOrdersByDateRange,
  OrdersByDateRangePage,
} from './orders-by-date-range-page';
import {
  IOrdersByPurchaseOrderNumber,
  OrdersByPurchaseOrderNumberPage,
} from './orders-by-purchase-order-number-page';

export const ORDERS_PAGE_ROUTE = '/orders';

export type OrdersPageParams =
  | IOrdersByDateRange
  | IOrdersByPurchaseOrderNumber
  | any;

export const ordersRoute = (soldToId: string, params: OrdersPageParams) => {
  const queryString = qs.stringify(params, { addQueryPrefix: true });
  const uid = getUserID();
  return `${ORDERS_PAGE_ROUTE}/${soldToId}${queryString}&uid=${uid}`;
};

const parseQueryString = (search: string): OrdersPageParams => {
  return qs.parse(search, {
    ignoreQueryPrefix: true,
  });
};

export default function OrdersPageRouting() {
  const { soldToId } = useParams();
  const { search } = useLocation();
  const params = parseQueryString(search);
  const { shipToId, status, vessel } = params;
  const statuses: Status[] =
    typeof status === 'string' ? (status.split(',') as Status[]) : [];

  const vesseles: string[] =
    typeof vessel === 'string' ? (vessel.split(',') as string[]) : [];

  if (soldToId && 'start' in params) {
    const { start, end } = params;
    return (
      <OrdersByDateRangePage
        soldToId={soldToId}
        start={start}
        end={end}
        shipToId={shipToId}
        statuses={statuses}
        vesseles={vesseles}
      />
    );
  } else if (soldToId && 'purchaseOrder' in params) {
    const { purchaseOrder } = params;
    return (
      <OrdersByPurchaseOrderNumberPage
        soldToId={soldToId}
        purchaseOrder={purchaseOrder}
        shipToId={shipToId}
        statuses={statuses}
        vesseles={vesseles}
      />
    );
  }
  return <PageNotFound />;
}
